import { useState } from "react";
import StyleWrapper, {
    StyleContentWrapper,
    StyleVolksHeader,
    StyleLineLeft,
    LogoVw,
    StyleLineRight,
    StyleButtonContainer,
} from "./style";
import Button from "components/button";

export default ({setIsModalOpen, setIsModalOpenWinners}) => {
    return (
        <>
            <StyleWrapper>
                <StyleContentWrapper>
                    <div>
                        <img
                            src="/assets/img/BEST_DRIVE_PREMIADO.svg"
                            alt="Volks Vale"
                        />
                    </div>
                    <div>
                        <StyleButtonContainer>
                            <Button onClick={() => setIsModalOpenWinners(true)}>
                                Ganhadores
                            </Button>
                            <br />
                            <br />
                            <p>Período de participação: de 25/10/2025 a 25/01/2026. </p>
                            <Button onClick={() => setIsModalOpen(true)}>
                                Consultar meu número da sorte
                            </Button>
                        </StyleButtonContainer>
                        <StyleVolksHeader>
                            <StyleLineLeft />
                            <LogoVw />
                            <StyleLineRight />
                        </StyleVolksHeader>
                        <p>
                            Período de participação: de 25/10/2025 a 25/01/2026.
                            Serão considerados válidos apenas os test drives
                            realizados nas concessionárias participantes e que
                            atendam aos parâmetros descritos no regulamento,
                            limitado a um prêmio por CPF. Certificado de
                            autorização N.° 04.045460/2025.
                        </p>
                    </div>
                </StyleContentWrapper>
            </StyleWrapper>
        </>
    );
};
